import { render } from "./TemplateFrameOptions.vue?vue&type=template&id=2471d982&scoped=true"
import script from "./TemplateFrameOptions.vue?vue&type=script&lang=js"
export * from "./TemplateFrameOptions.vue?vue&type=script&lang=js"

import "./TemplateFrameOptions.vue?vue&type=style&index=0&id=2471d982&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2471d982"]])

export default __exports__